(ns machtfit.product-form.visibility
  (:require [machtfit.dashboard-widgets :as widgets]
            [machtfit.product-form.section :refer [show-next-section]]
            [re-frame.core :as rf]))

(rf/reg-event-db ::set-visibility
  (fn [db [_ visibility-key visibility-val]]
    (assoc-in db [:product :visibility visibility-key] visibility-val)))

(defn section-visibility []
  [widgets/section
   {:anchor "visibility"
    :title "Zeitfenster"
    :content
    [:div
     [:div.col.s12
      [:span {:style {:margin "10px 0"
                      :display "flex"}}
       "Die automatische Veröffentlichung / Deaktivierung des Angebots erfolgt jeweils um 00:00 Uhr."]
      [:div.valign-wrapper
       [:span "Angebot veröffentlicht ab: "
        [widgets/inline-date-input
         {:read-only? false
          :required? false
          :value @(rf/subscribe [:get [:product :visibility :start-date]])
          :on-save #(rf/dispatch [::set-visibility :start-date %])}]]]
      [:div.valign-wrapper
       [:span "Angebot deaktiviert ab: "
        [widgets/inline-date-input
         {:read-only? false
          :required? false
          :value @(rf/subscribe [:get [:product :visibility :end-date]])
          :on-save #(rf/dispatch [::set-visibility :end-date %])}]]
       [:span {:style {:font-size "0.8rem" :cursor "default" :color "#9e9e9e" :margin "0.5rem 1rem"}}
        "Ab diesem Datum ist das Produkt nicht mehr buchbar."]]]

     [show-next-section :visibility]]}])
